import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.less';
import {
  Form, Input, Button, message,
} from 'antd';
import { FormattedMessage } from 'react-intl';
import QRCode from 'qrcode-react';
import wrapReact from '../../../util/react';
// import { DOMAIN } from '../../../config';
import { msgCB } from '../../../util/fetch/msgFetch';
import { actUI } from '../../../redux/action/ui';
import { CB_STATUS } from '../../../util/fetch/cFetch';
import { sessionStore } from '../../../util/storage';

const FormItem = Form.Item;

export class NewForm extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    const {
      intl, form, onSubmit, dispatch,
    } = this.props;
    const { formatMessage } = intl;
    const cb = (res) => {
      actUI(dispatch, {
        uiAccount: {
          uiEditForm: { loading: false },
          uiTable: { loading: false },
        },
      });
      if (res.status === CB_STATUS.SUCCESS) {
        form.resetFields();
      }
      switch (res.status) {
        case CB_STATUS.EXIST:
          form.setFields({
            displayName: {
              value: form.getFieldValue('displayName'),
              errors: [
                formatMessage({
                  id: 'Account.checkDisplayName.exist',
                  defaultMessage: 'display name already exists',
                }),
              ],
            },
          });
          break;
        default:
          msgCB(res.status, formatMessage);
          break;
      }
    };
    form.validateFields((err, values) => {
      if (!err) {
        //                console.log('Received values of form: ', values);
        const t = {
          Name: values.accountName,
          DisplayName: values.displayName,
          Password: values.accountPassword,
        };
        const reg = /([\x21-\x7E])[^\1]{0,}\1/g;
        if (reg.test(values.accountPassword)) {
          const lang = sessionStore.get('lang');
          if (lang === 'en') {
            message.error('Duplicate characters are not allowed!');
          } else {
            message.error('Doppelte Zeichen sind nicht erlaubt!');
          }
        } else {
          actUI(dispatch, {
            uiAccount: {
              uiEditForm: { loading: true },
              uiTable: { loading: true },
            },
          });
          onSubmit(t, cb);
        }
      }
    });
  }

  handleCancel = () => {
    const { form, onCancel } = this.props;
    form.resetFields();
    onCancel();
  }

  render() {
    const {
      intl, form, filePath, className, ui,
    } = this.props;
    const { formatMessage } = intl;
    const { getFieldDecorator } = form;
    // console.log(JSON.stringify(ui));
    // const { data } = ui;
    // const { AssociatedDevice } = data;
    // const domainPath = AssociatedDevice.length < 8 ? window.sipDomain : window.newSipDomain;
    const domainPath = window.newSipDomain;
    const upperPwd = `The uppercase pwssword is: ${ui.data.Password.toUpperCase()}`;
    return (
      <Form
        layout="horizontal"
        onSubmit={this.handleSubmit}
        className={`${filePath} ${className}`}
      >
        <div className="qrcode-con">
          <FormItem className="form-qr-item">
            <QRCode
              value={`{"s":"${domainPath}","u":"${ui.data.AccountName}","p":"${ui.data.Password}"}`}
            />
          </FormItem>
        </div>
        <FormItem
          label={formatMessage({
            id: 'Account.displayName',
            defaultMessage: 'display name',
          })}
        >
          {getFieldDecorator('displayName', {
            rules: [
              {
                required: true,
                message: formatMessage({
                  id: 'Account.displayNameCheck',
                  defaultMessage: 'please input display name',
                }),
              },
              {
                max: 20,
                min: 1,
                message: formatMessage({
                  id: 'validator.invalidLength',
                  defaultMessage: 'length of input is not ok',
                }),
              },
              {
                pattern: /^[A-Za-z0-9äöüÄÖÜß\s]*$/,
                message: formatMessage({
                  id: 'validator.noSpecialChar',
                  defaultMessage: 'only a-z, A-Z, 0-9 charaters are accepted',
                }),
              },
            ],
            initialValue: ui.data.DisplayName,
          })(<Input autoComplete="off" />)}
        </FormItem>
        <FormItem
          label={formatMessage({
            id: 'Account.accountName',
            defaultMessage: 'account name',
          })}
        >
          {getFieldDecorator('accountName', {
            initialValue: ui.data.AccountName,
          })(<Input disabled />)}
        </FormItem>
        <FormItem
          label={formatMessage({
            id: 'Account.accountPassword',
            defaultMessage: 'account password',
          })}
        >
          {getFieldDecorator('accountPassword', {
            rules: [
              {
                required: true,
                message: formatMessage({
                  id: 'Account.accountPwdCheck',
                  defaultMessage: 'please input account password',
                }),
              },
              {
                max: 18,
                min: 8,
                message: formatMessage({
                  id: 'password.invalidLength',
                  defaultMessage: 'Must enter 8-18 high strength passwords',
                }),
              },
              {
                // pattern: /^[A-Za-z0-9]*$/,
                pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\x21-\x7E]{8,18}$/,
                message: formatMessage({
                  id: 'validator.pwdRule2',
                  defaultMessage: 'only a-z, A-Z, 0-9 charaters are accepted',
                }),
              },
              // {
              //   // pattern: /^[A-Za-z0-9]*$/,
              //   pattern: /(\w)[^\1]{0,}\1/g,
              //   message: formatMessage({
              //     id: 'validator.pwdRule3',
              //     defaultMessage: 'Duplicate characters are not allowed',
              //   }),
              // },
              // ({ getFieldValue }) => ({
              //   validator(_, value) {
              //     let reg = /(\w)[^\1]{0,}\1/g
              //     if (!reg.test(value)) {
              //       return Promise.resolve
              //     }
              //     return Promise.reject(
              //       new Error('Duplicate characters are not allowed!'),
              //     )
              //   },
              // }),
            ],
            initialValue: ui.data.Password,
          })(<Input maxLength={18} title={upperPwd} />)}
        </FormItem>
        <FormItem
          label={formatMessage({
            id: 'Account.domain',
            defaultMessage: 'account domain',
          })}
        >
          {getFieldDecorator('accountDomain', {
            initialValue: domainPath,
          })(<Input disabled />)}
        </FormItem>
        <FormItem
          label={formatMessage({
            id: 'Account.associatedDevice',
            defaultMessage: 'associated device',
          })}
        >
          {getFieldDecorator('deviceAssociated', {
            initialValue: ui.data.AssociatedDevice,
          })(<Input disabled />)}
        </FormItem>
        <FormItem
          label={formatMessage({
            id: 'Account.displayName',
            defaultMessage: 'display name',
          })}
        >
          {getFieldDecorator('deviceDisplayName', {
            initialValue: ui.data.DeviceDisplayName,
          })(<Input disabled />)}
        </FormItem>

        {ui.data.Device_Type && (
          <FormItem
            label={formatMessage({
              id: 'Account.bindDevice',
              defaultMessage: 'Bind Device',
            })}
          >
            {getFieldDecorator('Device_Type', {
              initialValue: ui.data.Device_Type,
            })(<Input disabled />)}
          </FormItem>
        )}

        <FormItem className="btn-area">
          <Button
            type="primary"
            onClick={this.handleCancel}
            className="form-bt"
          >
            <FormattedMessage id="app.btn.cancel" defaultMessage="cancel" />
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={ui.loading}
            className="form-bt"
          >
            <FormattedMessage id="app.btn.ok" defaultMessage="ok" />
          </Button>
        </FormItem>
      </Form>
    );
  }
}

NewForm.propTypes = {
  ui: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    data: PropTypes.shape({
      DisplayName: PropTypes.string.isRequired,
      AccountName: PropTypes.string.isRequired,
      Password: PropTypes.string.isRequired,
      Device_Type: PropTypes.string.isRequired,
      AssociatedDevice: PropTypes.string.isRequired,
      DeviceDisplayName: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default Form.create()(wrapReact(NewForm, 'container_account_EditForm'));
